import { createContext, useContext, useEffect, useState } from "react";

const DarkModeContext = createContext({
    darkMode: false,
    toggleDarkMode: () => { },
    loadCorrectTheme: () => { }
});

export const DarkModeProvider = ({ children }) => {
    const [darkMode, setDarkMode] = useState(() => {
        return document.documentElement.classList.contains("dark");
    });

    useEffect(() => {
        const observer = new MutationObserver(() => {
            setDarkMode(document.documentElement.classList.contains("dark"));
        });

        observer.observe(document.documentElement, { attributes: true });

        return () => observer.disconnect();
    }, []);

    const toggleDarkMode = async (saveToDB, idUtente) => {

        if (saveToDB) {
            const response = await fetch('/aggiornaTemaUtente', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    ID: idUtente,
                    Tema: !darkMode
                }),
            });

            if (response.status === 500) {
                console.log("Errore nell'aggiornamento del tema utente");
            }
        };

        document.documentElement.classList.toggle("dark");
        setDarkMode(!darkMode);
    };

    const loadCorrectTheme = async (isSystemTheme, idUtente) => {
        if (isSystemTheme) {
            const dark = window.matchMedia('(prefers-color-scheme: dark)').matches;
            document.documentElement.classList.toggle("dark", dark);
            setDarkMode(dark);
            localStorage.setItem("theme", "system");
        }
        else {
            try {
                const response = await fetch('/getTemaUtente', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        ID: idUtente
                    }),
                });

                const data = await response.json();

                if (response.status === 500) {
                    console.log("Errore nel caricamento del tema utente");
                }
                else {
                    document.documentElement.classList.toggle("dark", data[0].Tema);
                    setDarkMode(data[0].Tema);
                    localStorage.setItem("theme", "database");
                }

            } catch (error) {
                console.error(error);
            }
        }
    }

    const getToken = () => {
        const match = document.cookie.match(/(?:^|;\s*)([^=]*token[^=]*)=([^;]*)/);
        return match ? match[2] : null;
    };
    

    useEffect(() => {
        const savedTheme = localStorage.getItem("theme");
        const idUser = getToken();
        if (savedTheme === "database") {
            loadCorrectTheme(false, idUser);
        } else {
            const dark = window.matchMedia('(prefers-color-scheme: dark)').matches;
            document.documentElement.classList.toggle("dark", dark);
            setDarkMode(dark);
        }
    }, []);

    return (
        <DarkModeContext.Provider value={{ darkMode, toggleDarkMode, loadCorrectTheme }}>
            {children}
        </DarkModeContext.Provider>
    );
};

export const useDarkMode = () => useContext(DarkModeContext);
